import { MutationTree } from "vuex";
import { RecipeDetailInfo, RecipesState, FavoriteOperationResult, FavoriteRecipeClips, FavoriteFolders } from "@/types/recipes";

const mutations: MutationTree<RecipesState> = {
  updateRecipeDetail: (state, detailInfo: RecipeDetailInfo | null) => {
    state.detailInfo = detailInfo;
  },
  updateAddRecipeMyList: async (state, result: FavoriteOperationResult | null) => {
    state.addRecipeResult = result;
  },
  updateDeleteRecipeMyList: (state, result: FavoriteOperationResult | null) => {
    state.deleteRecipeResult = result;
  },
  updateRecentMyList: (state, clips: FavoriteRecipeClips | null) => {
    state.recentMyList = clips;
  },
  updateFolderList: (state, folders: FavoriteFolders | null) => {
    state.folderList = folders;
  }
};

export default mutations;
